<template>
  <empty-layout>
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-header border-0">
            <h4 class="card-title">Certification</h4>
          </div>
          <div class="card-body pt-0">
            <div class="transaction-table">
              <div class="table-responsive">
                The certification application you submitted is under review, we
                will process it within 3 working days, please wait patiently.
              </div>
              <div style="text-align: center; margin: 15px"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </empty-layout>
</template>
<script>
import EmptyLayout from "../../components/layouts/EmptyLayout.vue";
import { formatNumber } from "../../plugins/operation";
export default {
  components: { EmptyLayout },
  mounted() {
    this.getdata();
  },
  data() {
    return {
      data: [],
      allLoaded: false,
      topStatus: "",
      page: 1,
      per_page: 10,
      pager: {},
    };
  },
  created() {},
  methods: {
    // formatNumber(num, precision, separator) {
    //   return formatNumber(num, precision, separator);
    // },
    // back() {
    //   this.$router.go(-1);
    // },
    // handlePageChange(val) {
    //   console.log(val);
    //   this.page = val;
    //   this.getdata();
    // },
    // getdata() {},
  },
};
</script>
